import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=f4bd3cca&scoped=true"
import script from "./register-form.vue?vue&type=script&lang=js"
export * from "./register-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bd3cca",
  null
  
)

export default component.exports